module.exports = __webpack_public_path__ + "images/e0558f3ffd9dd4aebc16baabc3b2c043.svg";